import IconPlayStore from '@assets/svg/icons/play-store-uncolored.svg'
import IconApple from '@fortuneo/ui-icons/general/IconApple'

type FooterData = Array<{
  label: string
  items: Array<{
    label: string
    slug?: string
    id?: string
    href?: string
    icon?: typeof IconApple | typeof IconPlayStore
  }>
}>

export const footerData: FooterData = [
  {
    label: 'Aide et contact',
    items: [
      {
        label: 'FAQ',
        slug: '/faq',
      },
      {
        label: 'Nous contacter / Réclamations',
        slug: '/contact',
      },
      {
        label: 'Formulaires',
        slug: '/formulaires',
      },
      {
        label: 'Accessibilité : non conforme',
        slug: '/accessibilite',
      },
      {
        label: 'Sécurité',
        slug: '/securite',
      },
      {
        label: 'Plan du site',
        slug: '/plan-site',
      },
    ],
  },
  {
    label: 'Nous connaitre',
    items: [
      {
        label: 'Qui sommes-nous ?',
        slug: '/qui-sommes-nous',
      },
      {
        label: 'Banque la moins chère',
        slug: '/palmares/banque/banque-la-moins-chere',
      },
      {
        label: 'Nos récompenses',
        slug: '/palmares',
      },
      {
        label: 'Nos engagements RSE',
        slug: '/responsabilite-societale-entreprise',
      },
      {
        label: 'Recrutement',
        slug: '/recrutement',
      },
      {
        label: 'Espace Presse',
        slug: '/espace-presse',
      },
    ],
  },
  {
    label: 'Informations réglementaires',
    items: [
      {
        label: 'Conditions générales',
        slug: '/formulaires#transverse',
      },
      {
        label: 'Conditions tarifaires',
        slug: '/tarifs',
      },
      {
        label: 'Politique de confidentialité',
        slug: '/mentions-legales-avertissement-legal#declaration-CNIL',
      },
      {
        label: 'Politique de cookies',
        slug: '/mentions-legales-avertissement-legal/depot-cookies-information',
      },
      {
        id: 'cookie-parameters',
        label: 'Paramétrer les cookies',
      },
      {
        label: 'Mentions légales',
        slug: '/mentions-legales-avertissement-legal',
      },
      {
        label: 'Réglementation',
        slug: '/informations-reglementees',
      },
      {
        label: 'Droit au compte et clients fragiles',
        slug: '/personnes-fragiles-droit-au-compte',
      },
      {
        label: "Dispositif d'alerte",
        slug: '/droit-alerte',
      },
    ],
  },
  {
    label: 'Appli mobile',
    items: [
      {
        label: 'App store',
        href: 'https://itunes.apple.com/fr/app/fortuneo/id385730327?mt=8',
        icon: IconApple,
      },
      {
        label: 'Google Play',
        href: 'https://play.google.com/store/apps/details?id=com.fortuneo.android',
        icon: IconPlayStore,
      },
    ],
  },
]
